import { AuthService } from './../../../../../services/auth.service';
import { CollaboratorService } from './../../../../../rest/api/collaborator.service';
import { HelperService } from './../../../../../services/helper.service';
import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-role-delete-collaborator',
  templateUrl: './role-delete-collaborator.component.html',
  styleUrls: ['./role-delete-collaborator.component.scss']
})
export class RoleDeleteCollaboratorComponent implements OnInit {

  @Input() collaborator;
  @Output() deleteCollaboratorEmit = new EventEmitter();

  deleteCollaboratorError: any;
  deleteCollaboratorSuccess: any;
  accessToken: any;
  langShortCode: any;
  isSubmitted = false;

  constructor(
    private authService: AuthService,
    public helperService: HelperService,
    public collaboratorService: CollaboratorService,
  ) {
      this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
      this.langShortCode = localStorage.getItem('language') ? localStorage.getItem('language') : undefined;
  }

  ngOnInit() {
    this.resetErrorValues();
  }

  deleteCollaborator(collaborator) {
    if (this.isSubmitted) {
      return;
    }
    this.isSubmitted = true;
    this.deleteCollaboratorError = undefined;
    this.collaboratorService.deleteCollaborator({
      Authorization: this.accessToken,
      id: collaborator.uuid
    }).subscribe((response: any) => {
      this.deleteCollaboratorSuccess = 'Collaborator was deleted successfully.';
      this.isSubmitted = false;
      this.deleteCollaboratorEmit.emit(response && response.data ? response.data : undefined);
    }, err => {
      if (err.error && err.error.error) {
        this.deleteCollaboratorError = err.error.error;
      } else {
        this.deleteCollaboratorError = 'There was error while deleting collaborator.';
      }
    });
  }

  resetErrorValues() {
    this.isSubmitted = false;
    this.deleteCollaboratorSuccess = undefined;
    this.deleteCollaboratorError = undefined;
  }

}
